import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import CardList from "./newUx/CardList/CardList";

const color = [
  "#E75E0D",
  "#EB9F11",
  "#ABC710",
  "#009340",
  "#CC0370",
  "#8366A9",
  "#149BD7",
];

export default function Contracts({ ChangeShowDetailHandler }) {
  const localData = useSelector((state) => state?.localStorage)
  const navigate = useNavigate();
  const { micrositeID, tabConfigId } = localData
  const [loading, setLoading] = useState(true);
  const [activeKey,] = useState("contract");
  const [responseData, setResponseData] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const id = micrositeID;

  const getContractsData = async (id) => {
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getContractsDetails(id, tabConfigId)
        );
        if (response) {
          setResponseData(response);
        }
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || 'Something went wrong'} />);
    }
    finally {
      setLoading(false);
    }
  };

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const onCardClickHandler = (data, id) => {
    navigate(`/microsite/${data.id}/micrositeDetails`, {
      state: { page: activeKey, data: data },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  useEffect(() => {
    getContractsData(id);
  }, [activeKey, id]);

  if (loading) {
    return (
      <div
        className="ant-tabs-content-holder"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader">
          <Spin tip="Loading" size="large" />
        </div>
      </div>
    );
  } else {
    return (
      <>
        <CardList
          responseData={responseData}
          color={color}
          PlayVideoHandler={PlayVideoHandler}
          convertToStandardURL={convertToStandardURL}
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          videoUrl={videoUrl}
          mediaType={mediaType}
          onCardClickHandler={onCardClickHandler}
        />
      </>
    );
  }
}
